import React from 'react';
import '@sensei/pi-component/dist/theme/browser-normalization.css';
import '@sensei/pi-component/dist/components/icon/LetterCircle/LetterCircle';
import PortalThemeProvider from '../src/context/PortalThemeProvider';
import { CssBaseline } from '@mui/material';
import { ErrorBoundary } from '../src/component/errorBoundary/ErrorBoundary';
import '../style/app.css';
import DeviceSyncProvider from '../src/component/device-sync-provider';
import OptInDialogWrapper from '../src/component/opt-in-dialog-wrapper';
import SnackbarProvider from '../src/component/snackbar-provider';
import ApolloProviderWrapper from '../src/auth/apollo-provider-wrapper';
import TermsAndConditionsAutoOpenDialog from '../src/component/terms-and-conditions-auto-open-dialog';
import JoinWithoutInvitationDialog from '../src/component/join-without-invitation-dialog';
import { I18nextProvider } from 'react-i18next';
import i18n from '../src/i18n';
import TrackingProvider from '../src/component/tracking-provider';
import { initSentry } from '../src/util/sentry';
import AuthProvider from '../src/auth/auth-provider';
import ToastMessageWrapper from '../src/component/message/toast-message-wrapper';

initSentry();

export default function App({
    Component,
    pageProps,
}: {
    Component: React.FC<any>;
    pageProps: object;
}) {
    return (
        <ErrorBoundary>
            <TrackingProvider>
                <I18nextProvider i18n={i18n}>
                    <SnackbarProvider>
                        <ApolloProviderWrapper>
                            <AuthProvider>
                                <DeviceSyncProvider>
                                    <PortalThemeProvider>
                                        <CssBaseline />
                                        <ToastMessageWrapper />
                                        <OptInDialogWrapper>
                                            <Component {...pageProps} />
                                            <TermsAndConditionsAutoOpenDialog />
                                            <JoinWithoutInvitationDialog />
                                        </OptInDialogWrapper>
                                    </PortalThemeProvider>
                                </DeviceSyncProvider>
                            </AuthProvider>
                        </ApolloProviderWrapper>
                    </SnackbarProvider>
                </I18nextProvider>
            </TrackingProvider>
        </ErrorBoundary>
    );
}
